import { authorizationStore } from '@/store/authorization';
import { consoleLogHeaders } from './common';
import axios from 'axios';
import appInsights from '@/AppInsights';
import localStorageWrapper from '@/capacitor/localStorageWrapper';

const endpoints = {
	local: 'http://localhost:4000',
	prod: 'https://altdata.shootpro.cloud',
};

const headerLog = consoleLogHeaders('SP-API');

const miscAxios = axios.create();

miscAxios.interceptors.request.use(async function (config) {
	config.baseURL = endpoints.prod;
	const useDevServer =
		(await localStorageWrapper.get('useNextServer')) ||
		window.location.host.includes('localhost:3254') ||
		window.location.host.includes('localhost:5173') ||
		window.location.host.includes('nice-meadow') ||
		window.location.host.includes('beta') ||
		(window.location.host.includes('next') &&
			!window.location.host.includes('next-spc-app'));
	if (
		window.location.href.includes('useLocalhostMisc=true') ||
		sessionStorage['useLocalhostMisc']
	) {
		if (!window.shownLocalWarning) {
			console.warn(
				"USING LOCAL FROM SESSIONSTORAGE. RUN `delete sessionStorage['useLocalhostMisc']` TO USE DEFAULT SERVER"
			);
			window.shownLocalWarning = true;
		}
		config.baseURL = endpoints.local;
		sessionStorage['useLocalhostMisc'] = true;
	}
	const authStore = authorizationStore();
	if (authStore.token) {
		config.headers.Authorization = `Bearer ${authStore.token}`;
	}
	config.headers['x-from-service'] = 'shooter-side-ui';
	if (useDevServer) {
		config.headers['X-Next-Server'] = 'yes';
	}
	return config;
});

miscAxios.interceptors.response.use(
	function (res) {
		headerLog(res);

		return res;
	},
	function (error) {
		// Any status codes that falls outside the range of 2xx cause this function to trigger
		if (
			error &&
			error.response &&
			error.response.status !== 401 &&
			error.response.status !== 402 &&
			error.response.status !== 406 &&
			error.response.status !== 416
		)
			console.error('[SP-API HTTP ERROR]', error.response || error);
		else console.warn('[SP-API HTTP WARNING]', error.response || error);

		if (error.response) headerLog(error.response);
		let errorTracker = {
			errorMessage: `${error}`,
			hasResponse: !!error.response,
		};

		if (errorTracker.hasResponse) {
			errorTracker.response = {
				headers: error.response.headers,
				data: error.response.data || 'null',
				statusCode: error.response.status,
			};
		}

		appInsights.trackTrace({
			message: 'axios.reject.shooter.side.api',
			severityLevel: 3,
			properties: errorTracker,
		});

		if (!error.response) {
			appInsights.trackException({
				exception: error,
				properties: {
					type: 'shooter-side-axios-call-nonhttp',
				},
			});
		}

		return Promise.reject(error);
	}
);

localStorageWrapper.get('useNextServer').then((x) => {
	if (x) {
		console.warn('Moving to next endpoint!');
		miscAxios.defaults.baseURL = endpoints.next;
	}
});

export default miscAxios;
